import { createSelector } from 'reselect';
import { isRunningContextCypress } from 'moet-test-utils/cypress/utils';
import { EXPERIMENTS, EXPERIMENTS_TO_USER_PROPS_MAP, } from '@/constants/experiments';
import { appState } from './utils';
const _experiments = createSelector(appState, ({ experiments }) => experiments);
export const getExperimentState = (experimentKey) => createSelector(_experiments, experiments => experiments[experimentKey]);
export const getExperimentsAsUserAttributes = createSelector(_experiments, (experiments) => {
    return Object.keys(EXPERIMENTS_TO_USER_PROPS_MAP).reduce((acc, curr) => (Object.assign(Object.assign({}, acc), { [EXPERIMENTS_TO_USER_PROPS_MAP[curr]]: experiments[curr] || 'off' })), {});
});
export const hasEmailConfirmationExperimentActive = createSelector(_experiments, experiments => !isRunningContextCypress(window) &&
    experiments[EXPERIMENTS.EMAIL_VALIDATION] === 'email_confirmation');
